export default function Admin404() {
  return (
    <div className="font-bold text-3xl text-gray-700 justify-center items-center flex py-[20vh]">
      Nothing here.
    </div>
  );
}
